/// The market chart's header line, as pure data so the claim it makes is
/// unit-testable away from the canvas.
///
/// One asset earns a special heading: frBTC's USD series is BTC/USD served
/// from Hyperliquid (the wrap is 1:1, so BTC's dollar chart IS frBTC's), and
/// the header says so — "frBTC · BTC/USD · 1 frBTC = 1 BTC" — instead of
/// pretending an alkanes feed priced it. Everything else keeps the standard
/// "<name> · all time in <denomination>" form.
export interface ChartHeading {
	/// The bold lead: "DIESEL · all time", "frBTC · BTC/USD".
	title: string
	/// The quiet tail: "in USD", "1 frBTC = 1 BTC".
	note: string
}

export function chartHeading(args: {
	title: string | null | undefined
	denomination: string
	source: string | undefined
	usdCovered: boolean
}): ChartHeading {
	if (args.usdCovered && args.source === 'hyperliquid') {
		return { title: 'frBTC · BTC/USD', note: '1 frBTC = 1 BTC' }
	}
	return {
		title: args.title ? `${args.title} · all time` : 'Price',
		note: `in ${args.denomination}`
	}
}
